<template>
    <component v-bind:is="componentFile" :data="data" :globalSet="globalSet" />
</template>
<script>
export default {
    props: {
        componentName: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        globalSet: {
            type: Object,
            required: true
        },
    },
    computed: {
        componentFile () {
            return () => import(`./pageBlocks/${this.componentName}`)
        }
    }
}
</script>
